import {getContactNumber, getSettings} from '../../selectors';
import validateContactNumberForOptty from './validateContactNumberForOptty';

export default (state, isToDisableOptty = false) => {
  const contactNumber = getContactNumber(state);
  const isValidContactNumber = validateContactNumberForOptty(contactNumber);
  
  if (isToDisableOptty && getSettings(state)?.validate_contact_number_for_optty_and_disable) {
    return !isValidContactNumber;
  }
  
  if (!isToDisableOptty && getSettings(state)?.validate_contact_number_for_optty_and_show_message) {
    return !isValidContactNumber;
  }
  
  return false;
};
